import { Link } from "react-router-dom";
import styled from "styled-components";

import { ContainerComponent } from "../../ui";

export const Wrapper = styled("header")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  position: "sticky",
  left: 0,
  top: 0,
  width: "100%",
  backgroundColor: "transparent",
  color: theme.palette.header.text,
  zIndex: 152,
  ...theme.paddings(10, 15, 0, 15),
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
}));

export const StyledContainer = styled(ContainerComponent)(({ theme }) => ({
  ...theme.mixins.flexCenterBetween,
  flexGrow: 1,
  gap: "24px",
  background:
    "linear-gradient(90.12deg, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0.7) 100%)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  borderRadius: "14px",
  boxShadow: `0 1px 8px ${theme.palette.shadow.light}`,
  ...theme.paddings(8, 20),

  [theme.down("lg")]: {
    gap: "16px",
  },
}));

export const LeftSection = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "32px",
  flexShrink: 0,
}));

export const NavTabs = styled("nav")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "4px",

  [theme.down("md")]: {
    display: "none",
  },
}));

export const NavIcon = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
  transition: "all 0.25s ease",
}));

export const NavText = styled("span")(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 400,
  letterSpacing: "0.01em",
  transition: "all 0.25s ease",
  whiteSpace: "nowrap",

  [theme.down("lg")]: {
    display: "none",
  },
}));

export const NavTab = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  padding: "10px 16px",
  borderRadius: "10px",
  color: theme.palette.header.text,
  textDecoration: "none",
  transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
  position: "relative",
  overflow: "hidden",

  "&:hover": {
    color: theme.palette.header.primary,
    backgroundColor: theme.palette.header.hoverBg,

    [`${NavIcon}`]: {
      transform: "scale(1.1)",
      color: theme.palette.header.primary,
    },
  },

  "&.active": {
    color: theme.palette.white,
    background: theme.palette.header.primary,

    [`${NavIcon}`]: {
      color: theme.palette.white,
    },

    [`${NavText}`]: {
      color: theme.palette.white,
      fontWeight: 700,
    },

    "&:hover": {
      background: theme.palette.header.primaryDark,
    },
  },

  [theme.down("lg")]: {
    padding: "10px 12px",
  },
}));

export const StyledLink = styled(Link)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  color: theme.palette.header.text,
  textDecoration: "none",
  fontSize: "14px",
  fontWeight: 400,
  padding: "8px 12px",
  borderRadius: "8px",
  transition: "all 0.2s ease",

  "&:hover": {
    color: theme.palette.header.primary,
    backgroundColor: theme.palette.header.hoverBg,
  },
}));
